import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Alerts from '../../utils/alerts';

import {
    Avatar,
    Button,
    Box,
    colors,
    Icon,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Typography,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200],
        color: colors.cyan[400]
    },
    container: {
        maxHeight: 340,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    },
    ifile: {
        display: 'inline - block',
        padding: '6px 12px',
        cursor: 'pointer',
        width: '100%',
    }
}));

const defaultProductLpu = {
    codigo: null,
    nome: null,
    UNIDADE: null,
    valor: 0.0,
    instalacao: 0.0,
    APLICACAO: null,
    REGIAO: -1
}

import { FaFileUpload } from "react-icons/fa";
import { GiPaperClip } from "react-icons/gi";

const Create = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const changeImportacao = (event, values) => {
        values = { IMPORTACAO: event.target.value, ...values };
    };

    const changeFile = (event, file) => {
        file.name = event.target.value;
        file = { name: event.target.value, ...file }
        document.getElementById('ifile' + file.id).value = event.target.value;
        dependencies.files.push(event.target.files[0]);
    }

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Novo Processo de Importação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                IMPORTACAO: Yup.string().required('Processo de Importação é obrigatório'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values, dependencies.estruturas, dependencies.files);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <Box className={classes.root} mt={1} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.codigo && errors.codigo)}
                                                fullWidth
                                                required
                                                label="Código"
                                                margin="none"
                                                name="codigo"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.codigo}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={10}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none" >
                                                <InputLabel shrink htmlFor="TIPO" required>Processo</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.IMPORTACAO && errors.IMPORTACAO)}
                                                    value={values.TIPO}
                                                    onChange={e => {
                                                        handleChange(e);
                                                        changeImportacao(e, values);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Processo"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'IMPORTACAO',
                                                        id: 'IMPORTACAO',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.importacoes.map((tipo) => (
                                                        <MenuItem key={tipo.id} value={tipo.id}>{tipo.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <TableContainer component={PerfectScrollbar}>
                                                <Table stickyHeader size="small" aria-label="a dense table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Descrição</TableCell>
                                                            <TableCell>Obrigatório</TableCell>
                                                            <TableCell width={40}>Arquivo</TableCell>
                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {dependencies.estruturas.map((arquivo, i) => (
                                                            (arquivo.importacao.id == values.IMPORTACAO) ?
                                                                <TableRow>
                                                                    <TableCell width={'30%'}>
                                                                        <Box
                                                                            alignItems="center"
                                                                            display="flex">
                                                                            <Avatar
                                                                                className={classes.avatar}
                                                                            >
                                                                                {<Icon component={FaFileUpload}></Icon>}
                                                                            </Avatar>
                                                                            {arquivo.descricao}
                                                                        </Box>
                                                                    </TableCell>
                                                                    <TableCell width={'10%'} >Sim</TableCell>
                                                                    <TableCell>
                                                                        <Button variant='contained' color='secondary' component="label" >
                                                                            <input
                                                                                type='file'
                                                                                hidden={true}
                                                                                id='file'
                                                                                name="file"
                                                                                accept={arquivo.formato}
                                                                                onChange={(event) => { changeFile(event, arquivo) }} />
                                                                            Escolher
                                                                        </Button>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <TextField variant='standard'
                                                                            required={true}
                                                                            className={classes.ifile}
                                                                            id={'ifile' + arquivo.id}
                                                                            value={arquivo.name} />
                                                                    </TableCell>
                                                                </TableRow>
                                                                : ""

                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Criar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
